import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'

import { sessionNew } from '../../actions/sessionActions'
import { Button } from '../utils/Button'

const SessionNewForm = () => {
  const emailInput = useRef()
  const dispatch = useDispatch()

  const handleSubmit = () => {
    dispatch(sessionNew(emailInput.current.value))
  }

  return (
    <div className="mb-12">
      <input
        className="text-3xl p-2 border border-gray-300 rounded-md mb-6 block w-full md:w-1/2"
        placeholder="Email Address"
        ref={emailInput}
      />

      <Button className="w-full md:w-1/2" color="green" onClick={handleSubmit}>
        Email me a sign in link!
      </Button>
    </div>
  )
}

export default SessionNewForm
